import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useAddExportModel from "@babackapp/private-api-client/client/use-add-export-model";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { t } from "i18next";
import { PropsWithChildren } from "react";
import ExportModelForm, { ExportModelFormValues } from "./export-model-form";

type AddExportModelModalProps = PropsWithChildren<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
}>;

export default function AddExportModelModal({
  children,
  open,
  onOpenChange,
}: AddExportModelModalProps) {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: addExportModel } = useAddExportModel(shop);

  const onSubmit = async (data: ExportModelFormValues) => {
    const fields = [
      ...data.delivery,
      ...data.result,
      ...data.settings,
      ...data.treatmentData,
    ];

    await addExportModel({
      fields,
      title: data.name,
      separator: data.separator,
    });

    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10 max-h-[calc(100vh-32px)] overflow-y-scroll">
        <DialogHeader>
          <DialogTitle>{t("exportModelModal.title")}</DialogTitle>
        </DialogHeader>
        <ExportModelForm onSubmit={onSubmit} />
      </DialogContent>
    </Dialog>
  );
}
